import React, { ReactNode } from "react";
import { formatDistanceToNowStrict, isValid } from "date-fns";

import {
  Group,
  Indicator,
  Text,
  ThemeIcon,
  UnstyledButton
} from "@mantine/core";

import {
  TbBook2,
  TbBulb,
  TbChecklist,
  TbFlask2,
  TbMessage,
  TbSocial,
  TbStarFilled,
  TbUsersGroup
} from "react-icons/tb";

import { INotification } from "modules/core/types/entities";

const MapNotificationTypeToIcon: Record<INotification["item_type"], ReactNode> =
  {
    Comment: <TbSocial size={18} />,
    CrowdSourceIdea: <TbUsersGroup size={18} />,
    Experiment: <TbFlask2 size={18} />,
    StoryHypothesis: <TbBulb size={18} />,
    StoryIdea: <TbBulb size={18} />,
    StoryTesting: <TbFlask2 size={18} />,
    ToDoItem: <TbChecklist size={18} />,
    Discussion: <TbMessage size={18} />,
    Research: <TbBook2 size={18} />
  };

interface IProps {
  item: INotification;
  onClick: () => void;
}

const NotificationItem: React.FC<IProps> = props => {
  const { item, onClick } = props;
  const {
    notification: title,
    created_at,
    link,
    item_type: type,
    visited: isVisited
  } = item;

  const isValidDate = isValid(new Date(created_at));

  return (
    <UnstyledButton
      component="a"
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      onClick={onClick}
      bg="gray.0"
      h={80}
      px="sm"
      display="block"
      style={{ borderRadius: "var(--mantine-radius-md)" }}
    >
      <Group wrap="nowrap" h="100%" justify="space-between">
        <Group wrap="nowrap" h="100%">
          <ThemeIcon
            variant="filled"
            color="dark"
            w={30}
            h={30}
            radius="xl"
            style={{ flexShrink: 0 }}
          >
            {MapNotificationTypeToIcon[type] || <TbStarFilled size={18} />}
          </ThemeIcon>

          <div>
            <Text fw={500} size="xs" lineClamp={2}>
              {title}
            </Text>

            {isValidDate ? (
              <Text fz={10} c="violet">
                {formatDistanceToNowStrict(new Date(created_at))}
              </Text>
            ) : null}
          </div>
        </Group>

        {!isVisited && <Indicator inline size={8} color="yellow" mr="xs" />}
      </Group>
    </UnstyledButton>
  );
};

export default React.memo(NotificationItem);
